<template>
    <div class="content-body">
        <LanguageSelector />
        <section id="basic-datatable">
            <div class="row">
                <div class="col-12">
                    <div class="text-right">
                        <CreateHouse from="house-list"/>
                        <!-- <router-link :to="{ name: 'CreateHousePage' }">
                            <button type="button" class="btn btn-primary mb-1">
                                <span class="align-middle ml-25">Create House</span>
                            </button>
                        </router-link> -->
                    </div>
                    <div class="card">
                        <div class="card-content"></div>
                        <div class="card-header">
                            <h5 class="card-title">{{$t('Manage Properties')}}</h5>
                            <div class="heading-elements rightSpacing">
                                <ul class="list-inline mb-0">
                                    <li class="spacing statusSpacing">
                                        <div class="has-icon-left searchBox">
                                            <select class="form-control" v-model="statusFilter" @change="filterByData()">
                                                <option selected>{{$t('All Status...')}}</option>
                                                <option value="preapproved">{{$t('Preapproved')}}</option>
                                                <option value="draft_by_admin">{{$t('Draft by Admin')}}</option>
                                                <option value="draft_by_landlord">{{$t('Draft by Landlord')}}</option>
                                                <option value="needs_approval_by_admin">{{$t('Needs approval by Admin')}}</option>
                                                <option value="needs_approval_by_landlord">{{$t('Needs approval by Landlord')}}</option>
                                                <option value="approved">{{$t('Approved')}}</option>
                                                <option value="rejected_by_admin">{{$t('Rejected by Admin')}}</option>
                                                <option value="rejected_by_landlord">{{$t('Rejected by Landlord')}}</option>
                                            </select>
                                            <div class="form-control-position">
                                                <em class="bx bx-filter font-medium-1"></em>
                                            </div>
                                        </div>
                                    </li>
                                    <li class="spacing">
                                        <div class="has-icon-left">
                                            <select class="form-control" v-model="cityFilter" @change="filterByData()">
                                                <option selected>{{$t('All Cities...')}}</option>
                                                <option v-for="(city, index) in allCities" :value="city" :key="index">{{ city }}</option>
                                            </select>
                                            <div class="form-control-position">
                                                <em class="bx bx-map font-medium-1"></em>
                                            </div>
                                        </div>
                                    </li>
                                    <li class="spacing">
                                        <div class="has-icon-left">
                                            <select class="form-control" v-model="countryFilter" @change="filterByData()">
                                                <option selected>{{$t('All Countries...')}}</option>
                                                <option v-for="(country, index) in usersCountries" :value="country" :key="index">{{ countryName(country) }}</option>
                                            </select>
                                            <div class="form-control-position">
                                                <em class="bx bx-map font-medium-1"></em>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="has-icon-left searchBox">
                                            <input type="text" class="form-control" @keyup="searchInTable()" v-model="searchInputText" :placeholder="$t('Search...')"/>
                                            <div class="form-control-position">
                                                <em class="bx bx-search font-medium-1"></em>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="card-body card-dashboard">
                            <div class="text-center">
                                <div class="spinner-border text-primary" role="status" v-if="loadingData" style="opacity: .6">
                                    <span class="sr-only">{{$t('Loading...')}}</span>
                                </div>
                            </div>
                            <div class="text-center mt-1" v-if="!properties.length && !loadingData">
                                <p>{{$t('No Houses Found...')}}</p>
                            </div>
                            <div class="table-responsive" v-if="properties.length">
                                <table class="table zero-configuration nowrap scroll-horizontal" :aria-label="$t('houses_arial_label_house_list')">
                                    <thead>
                                        <tr>
                                            <th>{{$t('House Name')}}</th>
                                            <th>{{$t('Status')}}</th>
                                            <th>{{$t('Country')}}</th>
                                            <th>{{$t('City')}}</th>
                                            <th>{{$t('Address')}}</th>
                                            <th>{{$t('Landlord')}}</th>
                                            <th>{{$t('Last Edited By')}}</th>
                                            <th>{{$t('Last Edited At')}}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(house, index) in properties" :key="index">
                                            <td v-if="house.name" class="houseName">
                                                <span>{{ house.name }}</span>
                                                <br>
                                                <small>{{$t('Created')}}: {{ house.createdAt.split('T')[0] }}</small>
                                                <br>
                                                <router-link :to="{name: 'EditHousePage', params: {uid: house.uid} }" style="margin-top: 5px;">
                                                    <em class="bx bx-edit-alt"></em> {{$t('Edit')}}
                                                </router-link>
                                            </td>
                                            <td class="capitalize">
                                                <span v-if="house.status == 'approved'"><em class="bx bxs-circle success font-small-1 mr-50"></em>{{ house.status }}</span>
                                                <span v-if="house.status == 'preapproved'"><em class="bx bxs-circle warning font-small-1 mr-50"></em>{{ house.status }}</span>
                                                <span v-if="house.status == 'banned'"><em class="bx bxs-circle danger font-small-1 mr-50"></em>{{ house.status }}</span>
                                                <span v-if="house.status == 'rejected_by_admin' || house.status == 'rejected_by_landlord'"><em class="bx bxs-circle danger font-small-1 mr-50"></em>{{ house.status.replaceAll("_", " ") }}</span>
                                                <span v-if="house.status == 'needs_approval_by_landlord' || house.status == 'needs_approval_by_admin'"><em class="bx bxs-circle info font-small-1 mr-50"></em>{{ house.status.replaceAll("_", " ") }}</span>
                                                <span v-if="house.status == 'draft_by_admin' || house.status == 'draft_by_landlord'"><em class="bx bxs-circle default font-small-1 mr-50"></em>{{ house.status.replaceAll("_", " ") }}</span>
                                            </td>
                                            <td v-if="house.country">{{ countryName(house.country) }}</td>
                                            <td v-else>-</td>
                                            <td v-if="house.address">
                                                {{ house.address.city }}
                                            </td>
                                            <td v-else>-</td>
                                            <td v-if="house.address">
                                                <span v-if="house.address.street">{{ house.address.street }}, {{ house.address.city }}</span>
                                                <span v-else>-</span>
                                                <br>
                                                <span v-if="house.address.zip">{{ house.address.zip }}</span>
                                                <span v-else>-</span>
                                            </td>
                                            <td v-else>-</td>
                                            <td v-if="house.owner.user">
                                                <span v-if="house.owner.user.name">{{ house.owner.user.name }}</span>
                                                <span v-else>
                                                    <span v-if="house.owner.user.email">{{ house.owner.user.email }}</span>
                                                    <span v-else>{{ house.owner.user.phoneNumber }}</span>
                                                </span>
                                            </td>
                                            <td v-if="house.owner.invite">
                                                <span v-if="house.owner.invite.name">{{ house.owner.invite.name }}</span>
                                                <span v-else>-
                                                    <span v-if="house.owner.invite.email">{{ house.owner.invite.email }}</span>
                                                    <span v-else>{{ house.owner.invite.phoneNumber }}</span>
                                                </span>
                                            </td>
                                            <td>
                                                {{ (house.lastEditedByUser && house.lastEditedByUser.name) ? house.lastEditedByUser.name : '-' }}
                                            </td>
                                            <td>{{ house.lastEditedAt.split('T')[0] }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
  import '@/app-assets/js/scripts/extensions/ext-component-block-ui.js'
  import { getCountryName } from '@/app-assets/js/get-countries.js'
  import CreateHouse from "@/components/Houses/CreateHouse";
    export default {
        data(){
            return {
                properties: [],
                activeCountries: [],
                usersCountries: [],
                allCities: [],
                loadingData: true,
                statusFilter: 'All Status...',
                countryFilter: 'All Countries...',
                cityFilter: 'All Cities...',
                searchInputText: ''
            }
        },

        components: {
            CreateHouse
        },

        computed: {
            isSuperadmin(){
                return this.$store.state.currentUser.user.type === 'superadmin'
            }
        },

        methods: {
            initDataTable(){
                let self = this
                setTimeout(function(){
                    $('.zero-configuration').DataTable({
                        "bLengthChange": false,
                        "bFilter": false,
                        "order": []
                    });
                }, 100)
            },

            getHouses(){
                let self = this
                self.properties = []
                this.loadingData = true

                this.$apiCall.get(`/v1/properties`)
                .then(response => {
                    let prop = [];
                    let url = [];
                    response.data.data.forEach(function(element){
                        if(!self.usersCountries.includes(element.country) && element.country){
                            self.usersCountries.push(element.country)
                        }

                        if(element.address && !self.allCities.includes(element.address.city) && element.address.city){
                            self.allCities.push(element.address.city)
                        }
                    })
                    self.properties = response.data.data;
                        self.loadingData = false
                        self.initDataTable()
                })
            },

            filterByStatus(status){
                let self = this
                if(status != 'All Status...'){
                    self.loadingData = true
                    self.properties = []
                    self.$apiCall.get(`/v1/properties?status=${status.toLowerCase()}`)
                    .then(response => {
                        response.data.data.forEach(function(element){
                            if(!self.usersCountries.includes(element.country) && element.country){
                                self.usersCountries.push(element.country)
                            }

                            if(element.address && !self.allCities.includes(element.address.city) && element.address.city){
                                self.allCities.push(element.address.city)
                            }
                        })

                        self.properties = response.data.data
                        self.loadingData = false
                        self.initDataTable()
                    })
                } else{
                    self.properties = []
                    self.getHouses()
                }
            },
              filterApiCall(data) {
            
            let self = this;
            self.$apiCall
                .get(`/v1/properties`, { params: data })
                .then(response => {
                    self.loadingData = false;
                    self.properties = response.data.data;
                    self.initDataTable();
                })
        },
        filterByData() {
            let self = this;
            self.properties = [];
            self.loadingData = true;
            let filterData = {};
            if (self.countryFilter != "All Countries...") {
                filterData.country = self.countryFilter;
            }
            if (self.statusFilter != "All Status...") {
                filterData.status = self.statusFilter;
            }
            if (self.cityFilter != "All Cities...") {
                filterData.city = self.cityFilter;
            }
            if (filterData.city || filterData.status || filterData.country) {
                self.filterApiCall(filterData)
            }
            else {
                self.properties = []
                self.usersCountries = [];
                self.allCities = [];
                self.getHouses();
            }
        },


            filterByCity(city){
                let self = this
                let properties = []
                if(city != 'All Cities...'){
                    self.loadingData = true
                    self.properties = []
                    self.$apiCall.get(`/v1/properties?city=${city}`)
                    .then(response => {
                        response.data.data.forEach(function(element){
                            if(!self.usersCountries.includes(element.country) && element.country){
                                self.usersCountries.push(element.country)
                            }

                            if(element.address && !self.allCities.includes(element.address.city) && element.address.city){
                                self.allCities.push(element.address.city)
                            }
                        })

                        self.properties = response.data.data
                        self.loadingData = false
                        self.initDataTable()
                    })
                } else{
                    self.properties = []
                    self.allCities = []
                    self.getHouses()
                }
            },

            filterByCountry(country){
                let self = this
                let properties = []
                if(country != 'All Countries...'){
                    self.loadingData = true
                    self.properties = []
                    self.$apiCall.get(`/v1/properties?country=${country}`)
                    .then(response => {
                        response.data.data.forEach(function(element){
                            if(!self.usersCountries.includes(element.country) && element.country){
                                self.usersCountries.push(element.country)
                            }

                            if(element.address && !self.allCities.includes(element.address.city) && element.address.city){
                                self.allCities.push(element.address.city)
                            }
                        })

                        self.properties = response.data.data
                        self.loadingData = false
                        self.initDataTable()
                    })
                } else{
                    self.properties = []
                    self.usersCountries = []
                    self.getHouses()
                }
            },

            getActiveCountries(){
                const countries = localStorage.getItem('activeCountries');
                this.activeCountries = (countries && countries != '') ? countries.split(',') : ["LB", "JO"];
            },

            countryName(element){
                if(element){
                    return getCountryName(element.toUpperCase())
                }
            },

            searchInTable(){
                var value = this.searchInputText.toLowerCase();
                $(".zero-configuration > tbody tr").filter(function() {
                    $(this).toggle($(this).find('.houseName > span').text().toLowerCase().indexOf(value) > -1)
                });
            },

        },

        mounted(){
            this.getHouses()
            this.getActiveCountries()
        }
    }
</script>

<style scoped>
    .zero-configuration td {
        white-space: nowrap;
    }
    .spacing{
        margin-right: 1em;
    }
    .searchBox{
        width:60%
    }
    .statusSpacing{
        margin-right: -6em;
    }
    .rightSpacing{
        right: -86px;
    }
</style>